import { render, staticRenderFns } from "./ResubmitTable.vue?vue&type=template&id=0d6284aa&"
import script from "./ResubmitTable.vue?vue&type=script&lang=js&"
export * from "./ResubmitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports